// Set to true to re-enable Aylık Ödeniş (monthly payment) button and page
export const AYLIK_ODENIS_ENABLED = true;

// Set to true to re-enable credit payment page
export const CREDIT_PAYMENT_ENABLED = true;

// Internal test payment HTML gateway — no site links point here; set false to hard-disable route
export const TEST_PAYMENT_PAGE_ENABLED = false;

/** Path segment after /:lang/ — must stay in sync with RouteValidator VALID_ROUTES */
export const TEST_PAYMENT_PATH_SEGMENT =
  "x9km7v3q2w8p4n6r1t-internal-tpay-bridge";
